export const enum ErrorType {
  ERROR = 'error',
  ERROR_2FA = 'error_2fa',
}